import { Directive, ElementRef, HostListener, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil, tap, throttleTime } from 'rxjs/operators';

/*
  Used to we would listen to the input box in the html for `(focus)=onFocus($event)`
  In the onFocus we would call `$event.target.select()` which would highlight all text

  Our E2E would run, and you could watch it start typing into the box, get 10 characters in
  then that text would highlight, then E2E would continue typing and clear out the existing
  leaving you with just the end of the string you expected to have

  This directive prevents focus from selecting if you've typed within the last half second.
  Hopefully this is the best of both worlds.

  WGT 2020-09-23
*/

@Directive({
  selector: '[ncTypeFocus]',
  standalone: false,
})
export class TypeFocusDirective implements OnDestroy {
  componentIsDestroyed$ = new Subject<void>();

  focus$ = new Subject<ElementRef>();

  constructor(private el: ElementRef) {
    this.focus$.pipe(
      throttleTime(1000),
      tap((element) => {
        if (!!element) {
          element.nativeElement.select();
        }
      }),
      takeUntil(this.componentIsDestroyed$),
    ).subscribe();
  }

  ngOnDestroy(): void {
    this.componentIsDestroyed$.next();
    this.componentIsDestroyed$.unsubscribe();
  }

  @HostListener('focus')
  focusChanged(): void {
    this.focus$.next(this.el);
  }

  @HostListener('keydown')
  typeHappened(): void {
    this.focus$.next(null);
  }
}
